import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LuTrash2 } from 'react-icons/lu';

import { TextInput } from 'cpool-components/input/TextInput';

import { FormDateInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDateInput';
import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';
import { FormPercentInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormPercentInput';
import { LEASING } from '../../../util/types';

type Props = {
    index: number;
    onRemove: () => void;
};

export const Leasing: React.FC<Props> = ({ index, onRemove }) => {
    const { t } = useTranslation();
    const { control, register } = useFormContext<ApplicantCreation>();

    return (
        <div className="rounded bg-white p-2.5 space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="text-sm font-semibold text-midnight">
                    {`${t(`EXISTING_LOANS.TYPES.${LEASING}`)} ${index + 1}`}
                </h4>
                <button
                    type="button"
                    onClick={onRemove}
                    className="p-2 text-alert-error hover:bg-alert-error/10 rounded"
                >
                    <LuTrash2 />
                </button>
            </div>

            <div className="grid grid-cols-2 gap-3">
                <FormCurrencyInput
                    id={`${LEASING}.${index}.rateMonatlich` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_MONTHLY_RATE')}
                    control={control}
                    min={0}
                />

                <FormCurrencyInput
                    id={`${LEASING}.${index}.schlussrate` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_FINAL_RATE')}
                    control={control}
                    min={0}
                />

                <FormDateInput
                    id={`${LEASING}.${index}.datumLetzteRate` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_LAST_RATE_DATE')}
                    control={control}
                />

                <TextInput
                    id={`${LEASING}.${index}.glaeubiger`}
                    label={t('EXISTING_LOANS.LOAN_CREDITOR')}
                    labelClassName="w-[175px] justify-start"
                    {...register(`${LEASING}.${index}.glaeubiger` as Path<ApplicantCreation>)}
                />

                <FormPercentInput
                    id={`${LEASING}.${index}.zinssatz` as Path<ApplicantCreation>}
                    label={t('EXISTING_LOANS.LOAN_INTEREST')}
                    control={control}
                    min={0}
                />
            </div>
        </div>
    );
};
